import React from 'react';

export const DeleteMessageModal = ({ open, onClose, onConfirm }) => {
    if (!open) return null;

    return (
        <div className="chat-delete-modal-overlay" onClick={onClose}>
            <div className="chat-delete-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="chat-delete-modal-close-btn" onClick={onClose} aria-label="Close">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                </button>
                <p className="chat-delete-modal-title">Delete message?</p>
                <p className="chat-delete-modal-text">
                    Are you sure you want to delete this message?
                    <br />
                    This action cannot be undone.
                </p>
                <div className="chat-delete-modal-buttons">
                    <button className="chat-delete-cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="chat-delete-confirm-btn" onClick={onConfirm}>
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};
